export { default } from "../inherits/_index.mjs"